function Widget(opts) {
    this.style = opts.style;
    this.loggedin = opts.loggedin;
    this.loading = opts.loading;
    this.translations = opts.translations;
    this.gateway_id = opts.gateway_id;
    this.enable_address = opts.enable_address;
    this.signup = false;
    this.init();
}

Widget.prototype.init = function () {
    if (this.style == "accordion") {
        $(document).on(
            "shown.bs.collapse",
            ".collapse",
            function () {
                if (typeof setHeight !== "undefined") {
                    setHeight();
                }
                if ($("#collapse5").hasClass("in")) {
                    this.reloadConfirmAndPay();
                }

                var elem = $(".collapse.in").prev();
                if (elem.length > 0) {
                    this.scrollParentTo(elem.offset().top);
                }
            }.bind(this),
        );
    }
    this.widgetLoaded("1");
};

Widget.prototype.initTable = function (container) {
    $(container).find(".continue-checkout-btn").on("click", this.selectPlan.bind(this));
    this.initQtySelectors(container);
    if ($(container).find(".continue-checkout-btn.btn-autoforward").length == 1) {
        setTimeout(function () {
            $(container).find("form").append('<input type="hidden" name="autosubmit" value="1">');
            $(container).find(".continue-checkout-btn.btn-autoforward").click();
        }, 250);
    } else {
        this.hideLoader();
    }
};

Widget.prototype.initUpsell = function (container) {
    $(container).find(".continue-checkout-btn").on("click", this.selectPlan.bind(this));
    $(container).find(".continue-checkout-all-btn").on("click", this.submitAll.bind(this));
    $(container).find(".continue-checkout-skip-btn").on("click", this.skipAll.bind(this));
    this.initQtySelectors(container);
    if ($(container).find(".continue-checkout-btn.btn-autoforward").length == 1) {
        if (this.style == "accordion") {
            setTimeout(function () {
                $(container).find("form").append('<input type="hidden" name="autosubmit" value="1">');
                $(container).find(".continue-checkout-btn.btn-autoforward").click();
            }, 250);
        } else {
            $(container).find("form").append('<input type="hidden" name="autosubmit" value="1">');
            $(container).find(".continue-checkout-btn.btn-autoforward").click();
        }
    } else {
        this.hideLoader();
    }
};

Widget.prototype.initMultiselect = function (container) {
    $(container).find(".continue-checkout-multi-btn").on("click", this.submitMulti.bind(this));
    this.initQtySelectors(container);
    this.hideLoader();
};

Widget.prototype.initForm = function (container) {
    $(container).find(".continue-checkout-btn").on("click", this.submitForm.bind(this));
    this.initQtySelectors(container);
    this.hideLoader();
};

Widget.prototype.initGiftCode = function (container) {
    $(container).find(".continue-checkout-btn").on("click", this.submitForm.bind(this));
    this.hideLoader();
};

Widget.prototype.initQtySelectors = function (container) {
    //plugin bootstrap minus and plus
    //http://jsfiddle.net/laelitenetwork/puJ6G/
    $(container)
        .find(".btn-number")
        .off("click")
        .click(function (e) {
            e.preventDefault();
            var fieldName = $(this).attr("data-field");
            var type = $(this).attr("data-type");
            var input = $(container).find("input[name='" + fieldName + "']");
            var currentVal = parseInt(input.val());
            if (!isNaN(currentVal)) {
                if (type == "minus") {
                    if (currentVal > input.attr("min")) {
                        input.val(currentVal - 1).change();
                    }
                    if (parseInt(input.val()) == input.attr("min")) {
                        $(this).attr("disabled", true);
                    }
                } else if (type == "plus") {
                    if (currentVal < input.attr("max")) {
                        input.val(currentVal + 1).change();
                    }
                    if (parseInt(input.val()) == input.attr("max")) {
                        $(this).attr("disabled", true);
                    }
                }
                if (input.val() > 0 && $(container).find("#widget-type").val() == "table") {
                    $(container)
                        .find(".input-number")
                        .each(function (i, el) {
                            if ($(el).attr("name") != input.attr("name")) {
                                $(el).val(0).change();
                            }
                        });
                }
            } else {
                input.val(0);
            }
        });
    $(container)
        .find(".input-number")
        .off("focusin")
        .focusin(function () {
            $(this).data("oldValue", $(this).val());
        });
    $(container)
        .find(".input-number")
        .off("change")
        .change(function () {
            var minValue = parseInt($(this).attr("min"));
            var maxValue = parseInt($(this).attr("max"));
            var valueCurrent = parseInt($(this).val());
            var name = $(this).attr("name");
            if (valueCurrent < minValue) {
                alert("Sorry, the minimum value was reached");
                $(this).val($(this).data("oldValue"));
            } else if (valueCurrent > minValue) {
                $(container)
                    .find(".btn-number[data-type='minus'][data-field='" + name + "']")
                    .removeAttr("disabled");
            } else {
                $(container)
                    .find(".btn-number[data-type='minus'][data-field='" + name + "']")
                    .attr("disabled", true);
            }
            if (valueCurrent > maxValue) {
                alert("Sorry, the maximum value was reached");
                $(this).val($(this).data("oldValue"));
            } else if (valueCurrent < maxValue) {
                $(container)
                    .find(".btn-number[data-type='plus'][data-field='" + name + "']")
                    .removeAttr("disabled");
            } else {
                $(container)
                    .find(".btn-number[data-type='plus'][data-field='" + name + "']")
                    .attr("disabled", true);
            }
        });
    $(container)
        .find(".input-number")
        .off("keydown")
        .keydown(function (e) {
            // Allow: backspace, delete, tab, escape, enter and .
            if (
                $.inArray(e.keyCode, [46, 8, 9, 27, 13, 190]) !== -1 ||
                // Allow: Ctrl+A
                (e.keyCode == 65 && e.ctrlKey === true) ||
                // Allow: home, end, left, right
                (e.keyCode >= 35 && e.keyCode <= 39)
            ) {
                // let it happen, don't do anything
                return;
            }
            // Ensure that it is a number and stop the keypress
            if ((e.shiftKey || e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105)) {
                e.preventDefault();
            }
        });
};

Widget.prototype.selectPlan = function (e) {
    var counter = $(e.target).data("plan");
    var container = $(e.target).closest("section");
    var qty = $(container)
        .find("#qty_" + counter)
        .val();
    if (qty < 1) {
        $(container)
            .find("#qty_" + counter)
            .val(1);
        qty = 1;
    }
    if (this.style == "accordion") {
        if ($(container).find("#widget-clear-cart").length > 0 && $(container).find("#widget-clear-cart").val() == "yes") {
            $.ajax({ type: "POST", url: "/clear-cart", async: false });
        }

        var form = $(container).find("#add_cart_" + counter);
        $.ajax({
            url: form.attr("action"),
            method: form.attr("method") ? form.attr("method") : "GET",
            data: form.serialize(),
            success: function (data) {
                if (typeof data === "object" && data.redirect) {
                    this.loadAnotherWidget(data.redirect);
                } else {
                    this.initCart(data);
                }
            }.bind(this),
        });
    } else {
        $(container)
            .find("#add_cart_" + counter)
            .submit();
    }
};

Widget.prototype.submitAll = function (e) {
    var container = $(e.target).closest("section");
    if (this.style == "accordion") {
        $(container).find(".submit_button").attr("disabled", true);
        setTimeout(function () {
            $(container).find(".submit_button").removeAttr("disabled");
        }, 5000);
    } else {
        $(container).find(".submit_button").replaceWith("..........");
    }
    if ($(container).find("#widget-clear-cart").length > 0 && $(container).find("#widget-clear-cart").val() == "yes") {
        $.ajax({ type: "POST", url: "/clear-cart", async: false });
    }
    $(container)
        .find(".qty")
        .each(function () {
            if ($(this).val() > 0) {
                var params = {
                    widget_uuid: $(this).attr("data-widget-uuid"),
                    upsell_index: $(this).attr("data-upsell-index"),
                    type: $(this).attr("data-type"),
                    sku: $(this).attr("data-sku"),
                    amount: $(this).attr("data-price"),
                    currency: $(this).attr("data-currency"),
                    description: $(this).attr("data-title"),
                    plan_id: $(this).attr("data-planid"),
                    qty: $(this).val(),
                    enable_quantity: $(this).closest("form").find("input[name=enable_quantity]").val(),
                    image: $(this).attr("data-image"),
                    product_id: $(this).attr("data-product-id"),
                    just_add: 1,
                };
                $.ajax({
                    type: "POST",
                    url: "/add-to-cart",
                    data: params,
                    async: false,
                });
            }
        });
    var redirect = $(container).find("#widget-forward-to").val();
    if (this.style == "accordion") {
        if (redirect.indexOf("/cart") > -1) {
            $.ajax({
                url: redirect,
                method: "GET",
                success: function (data) {
                    this.initCart(data);
                }.bind(this),
            });
        } else {
            this.loadAnotherWidget(redirect);
        }
    } else {
        window.location.href = redirect;
    }
};

Widget.prototype.skipAll = function (e) {
    var container = $(e.target).closest("section");
    if (this.style == "accordion") {
        $(container).find(".submit_button").attr("disabled", true);
        setTimeout(function () {
            $(container).find(".submit_button").removeAttr("disabled");
        }, 5000);
    } else {
        $(container).find(".submit_button").replaceWith("..........");
    }
    var redirect = $(container).find("#widget-forward-to").val();
    if (this.style == "accordion") {
        if (redirect.indexOf("/cart") > -1) {
            $.ajax({
                url: redirect,
                method: "GET",
                success: function (data) {
                    this.initCart(data);
                }.bind(this),
            });
        } else {
            this.loadAnotherWidget(redirect);
        }
    } else {
        window.location.href = redirect;
    }
};

Widget.prototype.submitMulti = function (e) {
    var container = $(e.target).closest("section");
    if (this.style == "accordion") {
        $(container).find(".submit_button").attr("disabled", true);
        setTimeout(function () {
            $(container).find(".submit_button").removeAttr("disabled");
        }, 5000);
    } else {
        $(container).find(".submit_button").replaceWith("..........");
    }
    if ($(container).find("#widget-clear-cart").length > 0 && $(container).find("#widget-clear-cart").val() == "yes") {
        $.ajax({ type: "POST", url: "/clear-cart", async: false });
    }
    $(container)
        .find(".qty")
        .each(function () {
            if ($(this).val() > 0) {
                var planid = $(this).attr("data-planid");
                var params = {
                    widget_uuid: $(this).attr("data-widget-uuid"),
                    plan_index: $(this).attr("data-plan-index"),
                    type: "plan",
                    qty: $(this).val(),
                    enable_quantity: $(this).closest("form").find("input[name=enable_quantity]").val(),
                    image: $(this).attr("data-image"),
                    just_add: 1,
                };
                params["plans_" + planid + "_id"] = planid;
                $.ajax({
                    type: "POST",
                    url: "/add-to-cart",
                    data: params,
                    async: false,
                });
            }
        });
    var redirect = $(container).find("#widget-forward-to").val();
    if (this.style == "accordion") {
        if (redirect.indexOf("/cart") > -1) {
            $.ajax({
                url: redirect,
                method: "GET",
                success: function (data) {
                    this.initCart(data);
                }.bind(this),
            });
        } else {
            this.loadAnotherWidget(redirect);
        }
    } else {
        window.location.href = redirect;
    }
};

Widget.prototype.submitForm = function (e) {
    var container = $(e.target).closest(".form-widget");
    if (this.style == "accordion") {
        var form = $(container).find("form");
        if (form.valid()) {
            $.ajax({
                url: form.attr("action"),
                method: form.attr("method") ? form.attr("method") : "GET",
                data: form.serialize(),
                success: function (data) {
                    if (typeof data === "object" && data.redirect) {
                        this.loadAnotherWidget(data.redirect);
                    } else {
                        this.initCart(data);
                    }
                }.bind(this),
            });
        }
    } else {
        $(container).find("form").submit();
    }
};

Widget.prototype.loadAnotherWidget = function (url) {
    var m = url.match(/widget\/([a-z0-9\-]+)/);
    var next = m[1];
    if ($("#collapse" + next).length == 0) {
        $("#collapse2")
            .parent()
            .before(
                '<div class="panel panel-default">' +
                    "\n" +
                    '				<div class="panel-heading" role="tab" id="heading' +
                    next +
                    '">' +
                    "\n" +
                    '					<h4 class="panel-title">' +
                    "\n" +
                    '						<a class="btn btn-link sessionfixed" role="button" data-wait="no" data-toggle="collapse" data-parent="#accordion" href="#collapse' +
                    next +
                    '" aria-expanded="false" aria-controls="collapse' +
                    next +
                    '">Next Widget</a>' +
                    "\n" +
                    "					</h4>" +
                    "\n" +
                    "				</div>" +
                    "\n" +
                    '				<div id="collapse' +
                    next +
                    '" class="panel-collapse collapse" role="tabpanel" aria-labelledby="heading' +
                    next +
                    '">' +
                    "\n" +
                    '					<div class="panel-body">' +
                    "\n" +
                    "					</div>" +
                    "\n" +
                    "				</div>" +
                    "\n" +
                    "			</div>",
            );
    }
    $.ajax({
        url: url,
        method: "GET",
        success: function (data) {
            $("#collapse" + next + " .panel-body").html(data);
            if (!$("#collapse" + next).hasClass("in")) {
                $("#heading" + next + " a").trigger("click.bs.collapse.data-api");
            }
            if (typeof setHeight !== "undefined") {
                setHeight();
            }
            this.widgetLoaded(next);
        }.bind(this),
    });
};

Widget.prototype.widgetLoaded = function (id) {
    var container = null;
    if (this.style == "accordion") {
        container = $("#collapse" + id).parent();
        $(container).find(".panel-title a").text($(container).find("#widget-name").val()).removeAttr("disabled");
        this.gaTrack("/widget/" + id);
    } else {
        container = $("section#plans");
        if (container.length == 0) {
            container = $(".container.form-widget");
        }
    }
    switch ($(container).find("#widget-type").val()) {
        case "table":
            this.initTable(container);
            break;
        case "upsell":
            this.initUpsell(container);
            break;
        case "multiselect":
            this.initMultiselect(container);
            break;
        case "form":
            this.initForm(container);
            break;
        case "giftcode":
            this.initGiftCode(container);
            break;
    }
};

Widget.prototype.hideLoader = function () {
    setTimeout(function () {
        window.parent.postMessage(
            {
                source: "paywhirl",
                frame: window.name,
                method: "hide-loader",
            },
            "*",
        );
    }, 250);
};

Widget.prototype.scrollParentTo = function (offset) {
    window.parent.postMessage(
        {
            source: "paywhirl",
            frame: window.name,
            method: "scroll-to",
            offset: offset,
        },
        "*",
    );
};

Widget.prototype.initCart = function (data) {
    this.gaTrack("/cart");
    $("#heading2 a").removeAttr("disabled");
    $("#collapse2 .panel-body").html(data);
    if (!$("#collapse2").hasClass("in")) {
        $("#heading2 a").trigger("click.bs.collapse.data-api");
    }
    $(".quantity-selectors i").on(
        "click",
        function (e) {
            var el = $(e.target);
            var index = el.parent().data("index");
            var qty = el.parent().data("qty");
            if (el.hasClass("fa-minus-square")) {
                qty = qty - 1;
            } else {
                qty = qty + 1;
            }
            $.post(
                "/add-to-cart",
                {
                    index: index,
                    plan_qty: qty,
                    force: true,
                    forward_to: "/cart",
                },
                function (data) {
                    if (typeof data === "object" && data.redirect) {
                        $.ajax({
                            url: data.redirect,
                            success: function (data) {
                                this.initCart(data);
                            }.bind(this),
                        });
                    } else {
                        this.initCart(data);
                    }
                }.bind(this),
            );
        }.bind(this),
    );
    $("#cart-continue-btn").on(
        "click",
        function () {
            if (this.loggedin) {
                this.switchAccountAddress();
            } else {
                $.ajax({
                    url: "/cart-account",
                    method: "GET",
                    success: function (data) {
                        this.initCartAccount(data);
                    }.bind(this),
                });
            }
        }.bind(this),
    );

    this.hideLoader();
};

Widget.prototype.initCartAccount = function (data) {
    this.gaTrack("/cart-account");
    this.loggedin = false;
    $("#heading3 a").removeAttr("disabled");
    $("#collapse3 .panel-body").html(data);
    $('#collapse3 .panel-body [data-toggle="tooltip"]').tooltip();
    if (!$("#collapse3").hasClass("in")) {
        $("#heading3 a").trigger("click.bs.collapse.data-api");
    }
    $("#login_form").on(
        "submit",
        function (e) {
            e.preventDefault();
            this.accountHandler(e.target);
        }.bind(this),
    );
    if ($.trim($("select.country_select").val()) == "") {
        $("select.country_select").val(window.default_country);
    }
    $(".country_select").select2();
    setTimeout(() => $(".country_select").trigger("change"), 100);
    setTimeout(() => $(".collapse.in").trigger("shown.bs.collapse"), 1000);
    try {
        loadGoogleMaps();
    } catch (e) {
        console.warn(e);
        gm_authFailure();
    }
};

Widget.prototype.accountHandler = function (form) {
    if (this.style != "accordion") {
        form.submit();
        return;
    }
    form = $(form);
    form.find("input[name=gateway_id]").val(this.gateway_id);
    if (form.attr("id") == "register_form") {
        this.signup = true;
    } else {
        this.signup = false;
    }
    $.ajax({
        url: form.attr("action"),
        method: form.attr("method") ? form.attr("method") : "GET",
        data: form.serialize(),
        success: function (data) {
            if (data.session_token) {
                $.ajaxSetup({
                    headers: {
                        "X-Session-Token": data.session_token,
                    },
                });
                window.parent.postMessage(
                    {
                        source: "paywhirl",
                        frame: window.name,
                        method: "set-session-token",
                        token: data.session_token,
                    },
                    "*",
                );
            }
            if (data.error) {
                $(".checkout_button").show();
                var next = $(".checkout_button").next();
                if (next.hasClass("waiting")) {
                    next.remove();
                }
                form.append(
                    '<div class="alert alert-danger" style="margin-top: 10px">' +
                        data.error +
                        '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>',
                ).alert();
                if (typeof grecaptcha !== "undefined") {
                    grecaptcha.reset();
                }
            } else if (data.status == "login") {
                Messenger({ extraClasses: "messenger-fixed messenger-on-right messenger-on-top" }).post({
                    message: "Account created, please login.",
                    type: "success",
                });
                $("#sign_up").hide();
                $("#login").fadeIn();
            } else {
                this.switchAccountAddress();
            }
        }.bind(this),
    });
};

Widget.prototype.switchAccountAddress = function () {
    this.loggedin = true;
    if (!this.enable_address) {
        this.cartPaymentMethod();
        return;
    }
    $("#heading3 a").removeAttr("disabled");
    $("#heading3 a").text(this.translations.address);
    if (this.signup) {
        $.ajax({
            url: "/cart-address",
            method: "GET",
            success: function (data) {
                $("#collapse3 .panel-body").html(data);
                this.signup = false;
                this.cartPaymentMethod();
            }.bind(this),
        });
    } else {
        $.ajax({
            url: "/cart-address",
            method: "GET",
            success: function (data) {
                this.initCartAddress(data);
            }.bind(this),
        });
    }
};

Widget.prototype.initCartAddress = function (data) {
    this.gaTrack("/cart-address");
    $("#heading3 a").removeAttr("disabled");
    $("#collapse3 .panel-body").html(data);
    if (!$("#collapse3").hasClass("in")) {
        $("#heading3 a").trigger("click.bs.collapse.data-api");
    }
    $(".shipping-address-dropdown").on(
        "change",
        function (e) {
            var address_id = $(e.target).val();
            $.ajax({
                url: "/cart-address",
                method: "GET",
                data: {
                    use_address: address_id,
                },
                success: function (data) {
                    this.initCartAddress(data);
                }.bind(this),
            });
        }.bind(this),
    );
    $(".logout")
        .off("click")
        .on(
            "click",
            function () {
                $.ajax({
                    url: "/cart-account?logout=1",
                    method: "GET",
                    success: function (data) {
                        $("#heading4 a").attr("disabled", "disabled");
                        $("#heading5 a").attr("disabled", "disabled");
                        this.initCartAccount(data);
                    }.bind(this),
                });
            }.bind(this),
        );
    loadGoogleMaps();
    setTimeout(() => $(".country_select").trigger("change"), 100);
};

Widget.prototype.addressHandler = function (form) {
    form = $(form);
    $.ajax({
        url: form.attr("action"),
        method: form.attr("method") ? form.attr("method") : "GET",
        data: form.serialize(),
        success: function (data) {
            if (data.error) {
                form.append(
                    '<div class="alert alert-danger" style="margin-top: 10px">' +
                        data.error +
                        '<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>',
                ).alert();
            } else {
                this.cartPaymentMethod();
            }
        }.bind(this),
    });
};

Widget.prototype.cartPaymentMethod = function () {
    $.ajax({
        url: "/cart-payment-method",
        method: "GET",
        success: function (data, status, xhr) {
            if (xhr.status === 204) {
                this.skipCartPaymentMethod();
                return;
            }
            this.initCartPaymentMethod(data);
        }.bind(this),
    });
};

// Skips payment method card when using UPE because then this extra step is not needed
Widget.prototype.skipCartPaymentMethod = function () {
    $("div.panel:has(#collapse4)").hide();
    window.widget.initConfirmAndPay();
};

Widget.prototype.initCartPaymentMethod = function (data) {
    this.gaTrack("/cart-payment-method");
    $("#heading4 a").removeAttr("disabled");
    $("#collapse4 .panel-body").html(data);
    if (!$("#collapse4").hasClass("in")) {
        $("#heading4 a").trigger("click.bs.collapse.data-api");
    }
    $("select[name=card_id]").on(
        "change",
        function (e) {
            var card_id = $(e.target).val();
            if (card_id == 0 && !$(e.target).data("payment-last-step")) {
                $("#add-a-card").show();
                $("#payment-method-continue-btn").parent().parent().hide();
                if (typeof setHeight !== "undefined") {
                    setHeight();
                }
            } else {
                $("#add-a-card").hide();
                $("#payment-method-continue-btn").parent().parent().show();
                if (typeof setHeight !== "undefined") {
                    setHeight();
                }
                $.ajax({
                    url: "/cart-card",
                    method: "POST",
                    data: {
                        card_id: card_id,
                    },
                    success: function () {
                        this.initConfirmAndPay();
                    }.bind(this),
                });
            }
        }.bind(this),
    );
    $("#payment-method-continue-btn").on(
        "click",
        function () {
            this.initConfirmAndPay();
        }.bind(this),
    );
    $("#continue-last-step-payment").on(
        "click",
        function () {
            this.initConfirmAndPay();
        }.bind(this),
    );
    $(".logout")
        .off("click")
        .on(
            "click",
            function () {
                $.ajax({
                    url: "/cart-account?logout=1",
                    method: "GET",
                    success: function (data) {
                        $("#heading4 a").attr("disabled", "disabled");
                        $("#heading5 a").attr("disabled", "disabled");
                        this.initCartAccount(data);
                        if (typeof destroyGateway === "function") {
                            // prevent initilizing the gateway again
                            destroyGateway();
                        }
                    }.bind(this),
                });
            }.bind(this),
        );
};

Widget.prototype.initConfirmAndPay = function () {
    this.gaTrack("/cart-confirm-pay");
    $("#heading5 a").removeAttr("disabled");
    if (!$("#collapse5").hasClass("in")) {
        $("#heading5 a").trigger("click.bs.collapse.data-api");
    }
};

Widget.prototype.reloadConfirmAndPay = function () {
    this.gaTrack("/cart-confirm-pay");
    $("#collapse5 .panel-body").html('<img src="' + this.loading + '" style="height:30px;"><br>');
    $.ajax({
        url: "/cart-confirm-pay",
        method: "GET",
        success: function (data) {
            $("#collapse5 .panel-body").html(data);
            $("#confirm-and-pay-btn").on("click", this.confirmAndPay.bind(this));
            if (typeof setHeight !== "undefined") {
                setHeight();
            }
        }.bind(this),
    });
};

Widget.prototype.confirmAndPay = function () {
    if (typeof checkPaymentFormCommon === "function") {
        if (!checkPaymentFormCommon()) {
            return false;
        }
    } else {
        Rollbar.error("checkPaymentFormCommon() not found");
    }
    $("#last_checkout_button").hide();
    $("#checkout_loading").show();
    if ($("#pay_and_checkout").length > 0) {
        $("#pay_and_checkout").submit();
    } else {
        $.ajax({
            url: "/checkout" + (document.getElementById("subscription-policy-checkbox")?.checked ? "?record_customer_consent=1" : ""),
            method: "GET",
            success: this.paymentIntentResponse.bind(this),
        });
    }
};

Widget.prototype.paymentIntentResponse = function (response) {
    if (response.error) {
        bootbox.alert(
            response.error,
            function () {
                // finish checkout and show error on invoice page
                $.ajax({
                    url: "/stripe-payment-intent",
                    type: "POST",
                    dataType: "json",
                    data: {
                        invoice_id: response.invoice_id,
                        checkout: true,
                        error: response.error,
                    },
                    success: this.paymentIntentResponse.bind(this),
                });
            }.bind(this),
        );
    } else if (response.requires_action) {
        stripe.client.handleCardAction(response.payment_intent_client_secret).then(
            function (result) {
                if (result.error) {
                    bootbox.alert(
                        result.error.message,
                        function () {
                            // finish checkout and show error on invoice page
                            $.ajax({
                                url: "/stripe-payment-intent",
                                type: "POST",
                                dataType: "json",
                                data: {
                                    invoice_id: response.invoice_id,
                                    checkout: true,
                                    error: result.error.message,
                                },
                                success: this.paymentIntentResponse.bind(this),
                            });
                        }.bind(this),
                    );
                } else {
                    // finish checkout and confirm intent
                    $.ajax({
                        url: "/stripe-payment-intent",
                        type: "POST",
                        dataType: "json",
                        data: {
                            invoice_id: response.invoice_id,
                            intent_id: result.paymentIntent.id,
                            checkout: true,
                        },
                        success: this.paymentIntentResponse.bind(this),
                    });
                }
            }.bind(this),
        );
    } else if (response.requires_3ds) {
        window.location.href = "/invoice/" + response.invoice_id;
    } else {
        if (response.conversionScripts) {
            $("body").append(response.conversionScripts);
        }
        setTimeout(function () {
            if (response.top) {
                top.location.href = response.redirect;
            } else {
                window.location.href = response.redirect;
            }
        }, 400);
    }
};

Widget.prototype.gaTrack = function (page) {
    if (typeof ga === "undefined") {
        return;
    }
    ga("set", "page", page);
    ga("send", "pageview");
};
